module.exports = __webpack_public_path__ + "img/mediumcloud.298fac44.svg";